module.exports = __webpack_public_path__ + "img/04.a814cc85.svg";